import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saUeCallDropRateChartConfig } from '../chartConfigs';

interface UeCallDropRateSaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const UeCallDropRateSaEcharts: React.FC<UeCallDropRateSaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saUeCallDropRateChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default UeCallDropRateSaEcharts;
